import * as React from 'react';
import { lazy, Suspense, useState } from 'react';
import {
   Button,
   useDisclosure,
   Modal,
   ModalOverlay,
   ModalContent,
   Skeleton,
} from '@chakra-ui/react';
import { getSearchClient } from 'Guide/searchClient';
import API_2_0 from 'Shared/api_2_0';
import * as HeaderActions from 'Shared/Header/actions';
import { store } from 'Shared/react-initialize';
import { _js } from '@ifixit/localize';

interface WorkbenchDevicePickerModalProps {
   onSelect: (_device: SelectedDeviceProps) => void;
   devicesInWorkbench: WorkbenchDevice[];
}

interface SelectedDeviceProps {
   deviceTitle: string;
   variantString: string;
}

interface WorkbenchDevice {
   title: string;
   variant: string;
}

export const WorkbenchDevicePickerModal = ({
   onSelect,
   devicesInWorkbench,
}: WorkbenchDevicePickerModalProps) => {
   const { isOpen, onOpen, onClose } = useDisclosure();
   const DevicePicker = lazy(() => import('workbench-device-picker'));

   const removeDeviceFromWorkbench = (deviceTitle: string, variantString: string) => {
      let request = new API_2_0('user/workbench/removeWithVariantString', {
         method: 'POST',
      })
         .send({
            device: deviceTitle,
            variant: variantString || null,
         })
         .then((response: any) => {
            store.dispatch(HeaderActions.updateWorkbench(response.topics));
         });

      LoadingIndicator.withPromise(request, {
         pendingMessage: _js('Removing'),
         successMessage: _js('Removed'),
      });
   };

   const fetchIDInfo = (deviceTitle: string): Promise<string> => {
      return new API_2_0(`wikis/CATEGORY/${deviceTitle}/identification`, {
         method: 'GET',
      })
         .send()
         .then((response: string) => {
            // eslint-disable-next-line no-console
            console.log(response);
            return response;
         });
   };

   return (
      <>
         <Button
            id="workbench-add-device"
            variant="solid"
            colorScheme="blue"
            color="white"
            fontWeight="semibold"
            borderRadius="4px"
            width="100%"
            py={2}
            height="38px"
            onClick={onOpen}
         >
            {_js('Add a Device')}
         </Button>
         <Modal
            isOpen={isOpen}
            onClose={onClose}
            scrollBehavior="inside"
            isCentered
            closeOnEsc
            closeOnOverlayClick
         >
            <ModalOverlay />
            <ModalContent p={0} height="85vh" width="532px" maxWidth="1064px">
               <Suspense fallback={<Skeleton height="100%" width="100%" />}>
                  <DevicePicker
                     algoliaConfig={
                        App.algoliaConfig && {
                           searchClient: getSearchClient(),
                           indexPrefix: App.algoliaConfig['indexPrefix'],
                        }
                     }
                     onSubmit={(value: SelectedDeviceProps) => {
                        onSelect(value);
                        onClose();
                     }}
                     onCancel={onClose}
                     devicesInWorkbench={devicesInWorkbench}
                     removeDeviceFromWorkbench={removeDeviceFromWorkbench}
                     fetchIDInfo={fetchIDInfo}
                  />
               </Suspense>
            </ModalContent>
         </Modal>
      </>
   );
};
